/* Parse public player location only. App identity/authentication never belongs in this URL. */
export function vimeoEmbedUrl(value) {
  if (typeof value !== "string" || value.length > 16384) return null;
  let raw = value.trim();
  if (!raw) return null;
  if (raw.includes("<")) {
    const iframe = raw.match(/<iframe\b[^>]*\ssrc\s*=\s*(?:"([^"]+)"|'([^']+)')/i);
    if (!iframe) return null;
    raw = (iframe[1] || iframe[2]).replace(/&amp;/gi, "&");
  }
  if (raw.startsWith("//")) raw = `https:${raw}`;
  let url;
  try { url = new URL(raw); } catch { return null; }
  if (url.protocol !== "https:" || url.username || url.password || url.port) return null;
  const player = url.hostname === "player.vimeo.com";
  if (!player && !["vimeo.com", "www.vimeo.com"].includes(url.hostname)) return null;
  const match = url.pathname.match(player ? /^\/video\/([1-9][0-9]{0,19})\/?$/ : /^\/([1-9][0-9]{0,19})(?:\/([A-Za-z0-9_-]{1,128}))?\/?$/);
  if (!match || url.searchParams.getAll("h").length > 1) return null;
  const queryHash = url.searchParams.get("h");
  const pathHash = match[2] || null;
  if (queryHash !== null && !/^[A-Za-z0-9_-]{1,128}$/.test(queryHash)) return null;
  if (queryHash && pathHash && queryHash !== pathHash) return null;
  const hash = queryHash || pathHash;
  const embed = new URL(`https://player.vimeo.com/video/${match[1]}`);
  if (hash) embed.searchParams.set("h", hash);
  return embed.toString();
}

/* Reuse the existing API renderer origin with only the current own App session. */
export function authenticatedVimeoEmbedUrl(value, apiBase, session) {
  const canonical = vimeoEmbedUrl(value);
  if (!canonical || !session || typeof session.loginUserId !== "string" ||
      !/^[1-9][0-9]*$/.test(session.loginUserId) ||
      typeof session.loginCookie !== "string" || !session.loginCookie.trim() ||
      /[\u0000-\u001f]/.test(session.loginCookie) ||
      !["student", "teacher"].includes(session.loginActionType)) return null;
  let api;
  try { api = new URL(apiBase); } catch { return null; }
  if (api.protocol !== "https:" || api.username || api.password || api.port ||
      !["www.api.salsaworldstandardclass.com", "api.salsaworldstandardclass.com"].includes(api.hostname) ||
      !/^\/function\.php\/?$/.test(api.pathname) || api.search || api.hash) return null;
  const player = new URL(canonical);
  const id = player.pathname.split("/").pop();
  const hash = player.searchParams.get("h");
  const code = id + (hash ? `?h=${hash}` : "");
  api.pathname = "/function.php/";
  api.search = new URLSearchParams({
    login_cookie: session.loginCookie,
    login_user_id: session.loginUserId,
    login_action_type: session.loginActionType,
    user_id: session.loginUserId,
    f: "getVimeoAuth",
    code,
    status: "1",
  }).toString();
  return api.toString();
}
